export class Divide {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        DivideFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_divide_free(ptr, 0);
    }
}
if (Symbol.dispose) Divide.prototype[Symbol.dispose] = Divide.prototype.free;

export class DivideParam {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        DivideParamFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_divideparam_free(ptr, 0);
    }
}
if (Symbol.dispose) DivideParam.prototype[Symbol.dispose] = DivideParam.prototype.free;

export class Hru {
    static __wrap(ptr) {
        const obj = Object.create(Hru.prototype);
        obj.__wbg_ptr = ptr;
        HruFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        HruFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_hru_free(ptr, 0);
    }
    /**
     * 根据面积百分比阈值对HRU进行重分类，返回新的hru名称
     *
     * @param min_area_p 面积百分比阈值
     * Example:
     *     hru.classify(0.1)
     * @param {number} min_area_p
     * @returns {any}
     */
    classify(min_area_p) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.hru_classify(retptr, this.__wbg_ptr, min_area_p);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 由JSON字符串创建Hru对象
     *
     * @param jstr JSON字符串
     *
     * @param {string} jstr
     * @returns {Hru}
     */
    static from(jstr) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(jstr, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.hru_from(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Hru.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}
if (Symbol.dispose) Hru.prototype[Symbol.dispose] = Hru.prototype.free;

export class Inp {
    static __wrap(ptr) {
        const obj = Object.create(Inp.prototype);
        obj.__wbg_ptr = ptr;
        InpFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        InpFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_inp_free(ptr, 0);
    }
    /**
     * 获取卡片数据
     *
     * @param name 卡片名称
     * Example: card_js('c50')
     *
     * @param {string} name
     * @returns {any}
     */
    card_js(name) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(name, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.inp_card_js(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {string[]}
     */
    card_names() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_card_names(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayJsValueFromWasm0(r0, r1);
            wasm.__wbindgen_export3(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 以表格形式格式化卡片数据
     * @param {string} name
     * @returns {string}
     */
    fmtcard(name) {
        let deferred3_0;
        let deferred3_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(name, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.inp_fmtcard(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr2 = r0;
            var len2 = r1;
            if (r3) {
                ptr2 = 0; len2 = 0;
                throw takeObject(r2);
            }
            deferred3_0 = ptr2;
            deferred3_1 = len2;
            return getStringFromWasm0(ptr2, len2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export3(deferred3_0, deferred3_1, 1);
        }
    }
    /**
     * 由压缩的JSON字符串创建Inp对象
     *
     * @param bstr 压缩的JSON字符串
     *
     * @param {string} bstr
     * @returns {Inp}
     */
    static from_b85z(bstr) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(bstr, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.inp_from_b85z(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Inp.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 由JSON字符串创建Inp对象
     *
     * @param jstr JSON字符串
     *
     * @param {string} jstr
     * @returns {Inp}
     */
    static from_str(jstr) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(jstr, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.inp_from_str(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Inp.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取蓄滞模拟水质参数分组id、名称、各子流域id及其对应的参数分组
     *
     * @return {Array<int>} grpid     蓄滞模拟水质参数分组id
     * @return {Array<str>} grpname   蓄滞模拟水质参数分组名称
     * @return {Array<int>} shpid     子流域id
     * @return {Array<int>} shpgrp    子流域对应的参数分组
     *
     * @returns {any}
     */
    get_conc_groups() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_conc_groups(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取自定义变量的计算公式
     * @returns {any}
     */
    get_custom_vars() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_custom_vars(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取指定子流域各个HRU的总面积(km^2)
     * subbasins: 要统计面积的子流域，为[]表示所有子流域
     * Example:
     * area = inp.get_hru_area([1, 2, 3])
     *
     * @param {Int32Array} subbasins
     * @returns {any}
     */
    get_hru_area(subbasins) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_hru_area(retptr, this.__wbg_ptr, addHeapObject(subbasins));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {any}
     */
    get_hru_property() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_hru_property(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {any}
     */
    get_hruname() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_hruname(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取初始条件-冷启动-水质模拟-陆域吸附态
     * @returns {any}
     */
    get_init_coldstart_adsorbed_land() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_init_coldstart_adsorbed_land(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取初始条件-冷启动-水质模拟-河道吸附态
     * @returns {any}
     */
    get_init_coldstart_adsorbed_reach() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_init_coldstart_adsorbed_reach(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取初始条件-冷启动-蓄滞模拟-水文
     * @returns {any}
     */
    get_init_coldstart_detention_hydro() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_init_coldstart_detention_hydro(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取初始条件-冷启动-蓄滞模拟-水质
     * @returns {any}
     */
    get_init_coldstart_detention_qual() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_init_coldstart_detention_qual(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取初始条件-冷启动-水文模拟-陆域
     * @returns {any}
     */
    get_init_coldstart_hydro_land() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_init_coldstart_hydro_land(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取初始条件-冷启动-水文模拟-河道
     * @returns {any}
     */
    get_init_coldstart_hydro_reach() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_init_coldstart_hydro_reach(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取初始条件-冷启动-水质模拟-陆域
     * @returns {any}
     */
    get_init_coldstart_qual_land() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_init_coldstart_qual_land(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取初始条件-冷启动-水质模拟-河道
     * @returns {any}
     */
    get_init_coldstart_qual_reach() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_init_coldstart_qual_reach(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取初始条件-冷启动-温度模拟-陆域
     * @returns {any}
     */
    get_init_coldstart_temp_land() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_init_coldstart_temp_land(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取初始化配置
     *
     * @return {bool} initfg                是否启用热启动文件
     *
     * @returns {boolean}
     */
    get_initfg() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_initfg(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return r0 !== 0;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取库塘信息-基本属性
     *
     * @returns {any}
     */
    get_lake_basic() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_lake_basic(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取库塘信息-几何属性
     *
     * @returns {any}
     */
    get_lake_geometry() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_lake_geometry(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取库塘信息-渗透属性
     *
     * @returns {any}
     */
    get_lake_permeation() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_lake_permeation(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取陆域参数分组id、名称、各子流域id及其对应的参数分组
     *
     * @return {Array<int>} grpid     陆域参数分组id
     * @return {Array<str>} grpname   陆域参数分组名称
     * @return {Array<int>} shpid     子流域id
     * @return {Array<int>} shpgrp    子流域对应的参数分组
     *
     * @returns {any}
     */
    get_land_groups() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_land_groups(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取陆域信息-HRU类型
     * @returns {any}
     */
    get_land_hru1() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_land_hru1(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取陆域信息-HRU设置
     * @returns {any}
     */
    get_land_hru2() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_land_hru2(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取陆域信息-子流域属性
     * @returns {any}
     */
    get_land_subbasin() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_land_subbasin(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取模型时间
     *
     * mstart   : 模拟起始时间, YYYY/MM/DD HH:mm:ss
     * mend     : 模拟结束时间, YYYY/MM/DD HH:mm:ss
     * deltm    : 模拟时间步长：1 hour
     * mostart  : 输出起始时间, YYYY/MM/DD HH:mm:ss
     * moend    : 输出结束时间, YYYY/MM/DD HH:mm:ss
     * optlevel : 输出时间步长，逐日/逐小时
     * tsPrint  : 状态输出时间, YYYY/MM/DD HH:mm:ss
     *
     * @returns {any}
     */
    get_model_time() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_model_time(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取模块开关状态
     *
     * @returns {any}
     */
    get_modules() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_modules(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取输出参数配置
     *
     * @returns {any}
     */
    get_output_config() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_output_config(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取高级模块-大棚模拟-大棚特性
     * @returns {any}
     */
    get_param_adv_greenhouse_property() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_adv_greenhouse_property(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取高级模块-大棚模拟-植被生长
     * @returns {any}
     */
    get_param_adv_greenhouse_vegetation() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_adv_greenhouse_vegetation(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取高级模块-大棚模拟-通风控制(月变值/基于棚内温度控制)
     * @returns {any}
     */
    get_param_adv_greenhouse_vomp() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_adv_greenhouse_vomp(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取高级模块-大棚模拟-通风控制(月度日变值)
     * @returns {any}
     */
    get_param_adv_greenhouse_vomp_daily() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_adv_greenhouse_vomp_daily(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取高级模块-蓄滞模拟-地表径流蓄滞水文参数
     * @returns {any}
     */
    get_param_adv_store_hydro() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_adv_store_hydro(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取高级模块-蓄滞模拟-地表滞留水质参数
     * @returns {any}
     */
    get_param_adv_store_wqual() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_adv_store_wqual(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取高级模块-负荷削减-面源削减控制
     * @returns {any}
     */
    get_param_adv_tmdlctrl_npsrc() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_adv_tmdlctrl_npsrc(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取高级模块-负荷削减-点源削减控制
     * @returns {any}
     */
    get_param_adv_tmdlctrl_ptsrc() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_adv_tmdlctrl_ptsrc(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取高级模块-负荷削减-控制开关
     *
     * reduction_ptsrc: 点源削减控制开关
     * reduction_npsrc_surface: 面源削减控制子开关，仅对地表径流应用削减
     * reduction_npsrc_total: 面源削减控制子开关，对陆域总出流应用削减
     * 面源削减控制开关( reduction_npsrc_surface || reduction_npsrc_total )
     *
     * @returns {any}
     */
    get_param_adv_tmdlctrl_switch() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_adv_tmdlctrl_switch(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取参数配置-水文模拟-蒸散发-恒值参数(c120)
     * @returns {any}
     */
    get_param_hydro_evap_const() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_hydro_evap_const(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取参数配置-水文模拟-蒸散发-lzetp(c100, c130, c200)
     * @returns {any}
     */
    get_param_hydro_evap_lzetp() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_hydro_evap_lzetp(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取参数配置-水文模拟-蒸散发-水面蒸发(c400)
     * @returns {any}
     */
    get_param_hydro_evap_water() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_hydro_evap_water(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取参数配置-水文模拟-下渗-恒值参数
     *
     * @returns {any}
     */
    get_param_hydro_infil_const() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_hydro_infil_const(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取参数配置-水文模拟-下渗-intfw(c100, c130, c180)
     * @returns {any}
     */
    get_param_hydro_infil_intfw() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_hydro_infil_intfw(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取参数配置-水文模拟-下渗-uzsn(c100, c130, c160)
     * @returns {any}
     */
    get_param_hydro_infil_uzsn() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_hydro_infil_uzsn(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取参数配置-水文模拟-灌溉-灌溉控制
     * @returns {any}
     */
    get_param_hydro_irrigation_control() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_hydro_irrigation_control(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取参数配置-水文模拟-灌溉-灌溉控制-自定义灌溉需水量时序开关
     * @returns {boolean}
     */
    get_param_hydro_irrigation_control_tseries_switch() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_hydro_irrigation_control_tseries_switch(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return r0 !== 0;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取参数配置-水文模拟-灌溉-etcoeff
     * @returns {any}
     */
    get_param_hydro_irrigation_etcoeff() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_hydro_irrigation_etcoeff(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取参数配置-水文模拟-灌溉-灌溉位置
     * @returns {any}
     */
    get_param_hydro_irrigation_fraction() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_hydro_irrigation_fraction(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取参数配置-水文模拟-灌溉-PET选择
     * @returns {any}
     */
    get_param_hydro_irrigation_pet() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_hydro_irrigation_pet(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取参数配置-水文模拟-灌溉-灌溉水源
     * @returns {any}
     */
    get_param_hydro_irrigation_source() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_hydro_irrigation_source(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取参数配置-水文模拟-灌溉-灌溉时间
     * @returns {any}
     */
    get_param_hydro_irrigation_time() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_hydro_irrigation_time(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取参数配置-水文模拟-产汇流-cepsc(c100, c130, c150)
     * @returns {any}
     */
    get_param_hydro_runoff_cepsc() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_hydro_runoff_cepsc(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取参数配置-水文模拟-产汇流-恒值参数(c110)
     * @returns {any}
     */
    get_param_hydro_runoff_const() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_hydro_runoff_const(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取参数配置-水文模拟-产汇流-irc(c100, c130, c190)
     * @returns {any}
     */
    get_param_hydro_runoff_irc() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_hydro_runoff_irc(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取参数配置-水文模拟-产汇流-nsur(c100, c130, c170)
     * @returns {any}
     */
    get_param_hydro_runoff_nsur() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_hydro_runoff_nsur(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取参数配置-水文模拟-开关（灌溉、干湿季调整）
     * @returns {any}
     */
    get_param_hydro_switch() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_hydro_switch(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取参数配置-水文模拟-干湿季调整-地下水出流乘子
     * @returns {any}
     */
    get_param_hydro_wetdryseason_agwo_mult() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_hydro_wetdryseason_agwo_mult(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取参数配置-水文模拟-干湿季调整-干湿季定义
     * @returns {any}
     */
    get_param_hydro_wetdryseason_definition() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_hydro_wetdryseason_definition(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取模型参数分组数
     *
     * @return {int} nlandgroup    陆域参数分组
     * @return {int} nreachgroup   河道参数分组
     * @return {int} nsurfgroup    蓄滞水文参数分组
     * @return {int} nconcgroup    蓄滞水质参数分组
     * @returns {any}
     */
    get_param_ngroups() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_ngroups(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取参数配置-水质模拟-累积冲刷-acqop
     *
     * 返回值中vqofg为0、1、2、3，分别表示：恒值、月变值、自定义时序、累积模式
     * 自定义时序的表格内容需要从文件中读取，该接口无法提供
     *
     * @returns {any}
     */
    get_param_quality_accumscour_acqop() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_quality_accumscour_acqop(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取参数配置-水质模拟-累积冲刷-恒值参数
     * @returns {any}
     */
    get_param_quality_accumscour_const() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_quality_accumscour_const(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取参数配置-水质模拟-累积冲刷-sqolim
     * @returns {any}
     */
    get_param_quality_accumscour_sqolim() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_quality_accumscour_sqolim(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取参数配置-水质模拟-大气沉降-addclnd
     * @returns {any}
     */
    get_param_quality_airdepos_addclnd() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_quality_airdepos_addclnd(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取参数配置-水质模拟-大气沉降-addcrch
     * @returns {any}
     */
    get_param_quality_airdepos_addcrch() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_quality_airdepos_addcrch(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取参数配置-水质模拟-大气沉降-awdclnd
     * @returns {any}
     */
    get_param_quality_airdepos_awdclnd() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_quality_airdepos_awdclnd(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取参数配置-水质模拟-大气沉降-awdcrch
     * @returns {any}
     */
    get_param_quality_airdepos_awdcrch() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_quality_airdepos_awdcrch(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取参数配置-水质模拟-大气沉降开关
     * @returns {boolean}
     */
    get_param_quality_airdepos_switch() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_quality_airdepos_switch(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return r0 !== 0;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取参数配置-水质模拟-河道水质-降解
     * @returns {any}
     */
    get_param_quality_reachqual_decay() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_quality_reachqual_decay(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取参数配置-水质模拟-土壤淋溶-aoqc
     * @returns {any}
     */
    get_param_quality_soilleach_aoqc() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_quality_soilleach_aoqc(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取参数配置-水质模拟-土壤淋溶-恒值参数
     * @returns {any}
     */
    get_param_quality_soilleach_const() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_quality_soilleach_const(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取参数配置-水质模拟-土壤淋溶-ioqc
     * @returns {any}
     */
    get_param_quality_soilleach_ioqc() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_quality_soilleach_ioqc(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 按工作簿 F-I 列的界面路径读取泥沙参数，所有数值沿用模型中的公制口径。
     * @param {string} level1
     * @param {string} level2
     * @param {string} level3
     * @param {string | null} [level4]
     * @returns {any}
     */
    get_param_sediment_card(level1, level2, level3, level4) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(level1, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(level2, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            const ptr2 = passStringToWasm0(level3, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len2 = WASM_VECTOR_LEN;
            var ptr3 = isLikeNone(level4) ? 0 : passStringToWasm0(level4, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            var len3 = WASM_VECTOR_LEN;
            wasm.inp_get_param_sediment_card(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取参数配置-温度模拟-河床热传导-恒值参数
     * @returns {any}
     */
    get_param_temp_bed_constant() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_temp_bed_constant(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取参数配置-温度模拟-河床热传导-模拟方法
     * @returns {any}
     */
    get_param_temp_bed_control() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_temp_bed_control(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取参数配置-温度模拟-河床热传导-tgrnd
     * @returns {any}
     */
    get_param_temp_bed_tgrnd() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_temp_bed_tgrnd(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取参数配置-温度模拟-土壤温度-agwt
     * @returns {any}
     */
    get_param_temp_soil_agwt() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_temp_soil_agwt(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取参数配置-温度模拟-土壤温度-aift
     * @returns {any}
     */
    get_param_temp_soil_aift() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_temp_soil_aift(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取参数配置-温度模拟-土壤温度-aslt
     * @returns {any}
     */
    get_param_temp_soil_aslt() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_temp_soil_aslt(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取参数配置-温度模拟-土壤温度-bgwt
     * @returns {any}
     */
    get_param_temp_soil_bgwt() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_temp_soil_bgwt(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取参数配置-温度模拟-土壤温度-bift
     * @returns {any}
     */
    get_param_temp_soil_bift() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_temp_soil_bift(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取参数配置-温度模拟-土壤温度-bslt
     * @returns {any}
     */
    get_param_temp_soil_bslt() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_temp_soil_bslt(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取参数配置-温度模拟-土壤温度-计算方法(tsopfg)
     * @returns {any}
     */
    get_param_temp_soil_method() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_temp_soil_method(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取参数配置-温度模拟-水体温度-温度系数
     * @returns {any}
     */
    get_param_temp_water_coeff() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_param_temp_water_coeff(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取点源温度和泥沙指标开关状态。
     * @returns {any}
     */
    get_point_qual_switches() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_point_qual_switches(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取河道参数分组id、名称、各河道id及其对应的参数分组
     *
     * @return {Array<int>} grpid     河道参数分组id
     * @return {Array<str>} grpname   河道参数分组名称
     * @return {Array<int>} shpid     河道id
     * @return {Array<int>} shpgrp    河道对应的参数分组
     *
     * @returns {any}
     */
    get_reach_groups() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_reach_groups(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取河道的拓扑关系
     *
     * @returns {any}
     */
    get_reach_topology() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_reach_topology(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取指定reach的所有上游reach
     *
     * Example:
     * inp.get_reach_upstreams(1)
     *
     * @param {number} reach_id
     * @returns {any}
     */
    get_reach_upstreams(reach_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_reach_upstreams(retptr, this.__wbg_ptr, reach_id);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取河道信息-基本属性
     *
     * @returns {any}
     */
    get_river_basic() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_river_basic(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取河道信息-断面属性-主河道横断面
     *
     * @param {Int32Array} rchids
     * @returns {any}
     */
    get_river_cross_section(rchids) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray32ToWasm0(rchids, wasm.__wbindgen_export);
            const len0 = WASM_VECTOR_LEN;
            wasm.inp_get_river_cross_section(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取河道信息-断面属性-主河道横断面-转换为自定义断面参数
     *
     * Example:
     * var custom = inp.get_river_cross_section_as_custom([1,2,3]);
     * @param {Int32Array} rchid
     * @returns {any}
     */
    get_river_cross_section_as_custom(rchid) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray32ToWasm0(rchid, wasm.__wbindgen_export);
            const len0 = WASM_VECTOR_LEN;
            wasm.inp_get_river_cross_section_as_custom(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取河道信息-断面属性-主河道横断面-转换为矩形参数
     *
     * Example:
     * var rectangle = inp.get_river_cross_section_as_rectangle([1,2,3]);
     * @param {Int32Array} rchid
     * @returns {any}
     */
    get_river_cross_section_as_rectangle(rchid) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray32ToWasm0(rchid, wasm.__wbindgen_export);
            const len0 = WASM_VECTOR_LEN;
            wasm.inp_get_river_cross_section_as_rectangle(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取河道信息-断面属性-主河道横断面-转换为梯形参数
     *
     * Example:
     * var trapezoid = inp.get_river_cross_section_as_trapezoid([1,2,3]);
     * @param {Int32Array} rchid
     * @returns {any}
     */
    get_river_cross_section_as_trapezoid(rchid) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray32ToWasm0(rchid, wasm.__wbindgen_export);
            const len0 = WASM_VECTOR_LEN;
            wasm.inp_get_river_cross_section_as_trapezoid(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取河道信息-水动力属性
     *
     * @returns {any}
     */
    get_river_hydro() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_river_hydro(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取河道信息-断面属性
     *
     * @returns {any}
     */
    get_river_section() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_river_section(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 模型编辑-全局设置-基础划分-参数分组
     * 针对每个子流域/河道，给出其陆域分组、河道分组、蓄滞水文分组、蓄滞水质分组的名称
     *
     * @returns {any}
     */
    get_sub_groups() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_sub_groups(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取Subbasin-HRU，返回csv文本内容
     * subbasin,hruid,hruname,area_m2,slsur_pct,lsur_m
     * @returns {string}
     */
    get_subbasin_hru_csv() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_subbasin_hru_csv(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export3(deferred2_0, deferred2_1, 1);
        }
    }
    /**
     * 获取蓄滞模拟水文参数分组id、名称、各子流域id及其对应的参数分组
     *
     * @return {Array<int>} grpid     蓄滞模拟水文参数分组id
     * @return {Array<str>} grpname   蓄滞模拟水文参数分组名称
     * @return {Array<int>} shpid     子流域id
     * @return {Array<int>} shpgrp    子流域对应的参数分组
     *
     * @returns {any}
     */
    get_surf_groups() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_surf_groups(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取模型水质组分
     *
     * @returns {any}
     */
    get_water_quals() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_water_quals(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取气象乘子(c20)
     * @returns {any}
     */
    get_weather_param_mult() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_weather_param_mult(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取气象站点与子流域的匹配权重(c60)
     * @returns {any}
     */
    get_weather_weight() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_get_weather_weight(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} card_name
     * @param {string} col_name
     */
    group_by(card_name, col_name) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(card_name, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(col_name, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            wasm.inp_group_by(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 本inp与另一个inp是否可比较
     * 参数：
     *     other: Inp
     * 返回值：bool
     * @param {Inp} other
     * @returns {boolean}
     */
    is_comparable(other) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(other, Inp);
            wasm.inp_is_comparable(retptr, this.__wbg_ptr, other.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return r0 !== 0;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 模型配置概览
     *
     * @returns {any}
     */
    model_config_overview() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_model_config_overview(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 显示卡片数据
     *
     * @param name 卡片名称
     * Example: print('c50')
     *
     * @param {string} name
     */
    prtcard(name) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(name, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.inp_prtcard(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 点源增删后的卡片更新
     * ptsrc: 点源总览信息
     * @param {Array<any>} ptsrc
     */
    ptsrc_related_update(ptsrc) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_ptsrc_related_update(retptr, this.__wbg_ptr, addBorrowedObject(ptsrc));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 重构HRU（在子流域内调整各个HRU的面积）
     * subbasins: 要调整面积的子流域, 为[]表示不重构任何子流域
     * hrus_ratio: 每个HRU会被映射到多个HRU，hrus_ratio为映射到的HRU的面积占比（包含自身）
     * preview_only: 是否仅预览不修改
     * Example:
     * hrus_ratio = {"Grassland_B_slope1": {"Grassland_B_slope1": 0.5, "Miningland_B_slope1": 0.5}}
     * inp.reconstruct_hru([1,2], hrus_ratio, true)
     *
     * @param {Int32Array} subbasins
     * @param {object} hrus_ratio
     * @param {boolean} preview_only
     * @returns {any}
     */
    reconstruct_hru(subbasins, hrus_ratio, preview_only) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_reconstruct_hru(retptr, this.__wbg_ptr, addHeapObject(subbasins), addHeapObject(hrus_ratio), preview_only);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} card_name
     * @param {string} field_name
     * @param {any} val
     */
    set_card_field_js(card_name, field_name, val) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(card_name, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(field_name, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            wasm.inp_set_card_field_js(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1, addBorrowedObject(val));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * @param {string} card_name
     * @param {any} val
     */
    set_card_js(card_name, val) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(card_name, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.inp_set_card_js(retptr, this.__wbg_ptr, ptr0, len0, addBorrowedObject(val));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置蓄滞模拟水质参数分组
     *
     * @param grpid     蓄滞模拟水质参数分组id
     * @param grpname   蓄滞模拟水质参数分组名称
     * @param refgrp    参考的蓄滞模拟水质参数分组
     * @param shpid     子流域id
     * @param shpgrp    子流域对应的参数分组
     *
     * Example:
     *
     * var group = inp.get_conc_groups();
     * var shpid = group.shpid;
     * var shpgrp = Array(shpid.length).fill(1);
     * shpgrp[1] = 2;
     * shpgrp[2] = 3;
     * var grpid = [1,2,3];
     * var grpname = ["蓄滞模拟水质分组一", "蓄滞模拟水质分组二", "蓄滞模拟水质分组三"];
     * var refgrp = [0,1,1];
     * var data = {'grpid': grpid, 'grpname': grpname, 'refgrp': refgrp, 'shpid': shpid, 'shpgrp': shpgrp};
     * inp.set_conc_groups(data);
     *
     * @param {object} data
     */
    set_conc_groups(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_conc_groups(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 获取自定义变量的计算公式——字符串
     * 设置自定义变量的计算公式
     *
     * Example:
     * var custom_vars = {'TP': [ [1,'ORG-P'], [1,'PO4'] ], 'TN': [ [1,'ORG-N'], [1,'NH4'], [1,'NO3'] ]};
     * inp.set_custom_vars(custom_vars);
     * @param {object} custom_vars
     */
    set_custom_vars(custom_vars) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_custom_vars(retptr, this.__wbg_ptr, addBorrowedObject(custom_vars));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置初始条件-冷启动-水质模拟-陆域吸附态
     * @param {object} data
     */
    set_init_coldstart_adsorbed_land(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_init_coldstart_adsorbed_land(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置初始条件-冷启动-水质模拟-河道吸附态
     * @param {object} data
     */
    set_init_coldstart_adsorbed_reach(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_init_coldstart_adsorbed_reach(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置初始条件-冷启动-蓄滞模拟-水文
     *
     * Example:
     * var init_detention_hydro = inp.get_init_coldstart_detention_hydro()
     * var data = init_detention_hydro['data']
     * data['retention_height'][0] += 0.1
     * inp.set_init_coldstart_detention_hydro(data)
     * @param {object} data
     */
    set_init_coldstart_detention_hydro(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_init_coldstart_detention_hydro(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置初始条件-冷启动-蓄滞模拟-水质
     *
     * Example:
     * var init_detention_qual = inp.get_init_coldstart_detention_qual()
     * var data = init_detention_qual['data']
     * data['surfcon'][0] += 0.1
     * inp.set_init_coldstart_detention_qual(data)
     * @param {object} data
     */
    set_init_coldstart_detention_qual(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_init_coldstart_detention_qual(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置初始条件-冷启动-水文模拟-陆域
     *
     * Example:
     * var init_hydro_land = inp.get_init_coldstart_hydro_land()
     * var data = init_hydro_land['data']
     * data['ceps'][0] += 0.1
     * inp.set_init_coldstart_hydro_land(data)
     *
     * @param {object} data
     */
    set_init_coldstart_hydro_land(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_init_coldstart_hydro_land(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置初始条件-冷启动-水文模拟-河道
     *
     * Example:
     * var init_hydro_reach = inp.get_init_coldstart_hydro_reach()
     * var data = init_hydro_reach['data']
     * data['idepth'][0] += 0.1
     * inp.set_init_coldstart_hydro_reach(data)
     *
     * @param {object} data
     */
    set_init_coldstart_hydro_reach(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_init_coldstart_hydro_reach(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置初始条件-冷启动-水质模拟-陆域
     *
     * Example:
     * var init_qual_land = inp.get_init_coldstart_qual_land()
     * var data = init_qual_land['data']
     * data['sqo'][0] += 0.1
     * inp.set_init_coldstart_qual_land(data)
     *
     * @param {object} data
     */
    set_init_coldstart_qual_land(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_init_coldstart_qual_land(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置初始条件-冷启动-水质模拟-河道
     *
     * Example:
     * var init_qual_reach = inp.get_init_coldstart_qual_reach()
     * var data = init_qual_reach['data']
     * data['iniCond'][0] += 0.1
     * inp.set_init_coldstart_qual_reach(data)
     * @param {object} data
     */
    set_init_coldstart_qual_reach(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_init_coldstart_qual_reach(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置初始条件-冷启动-温度模拟-陆域
     *
     * Example:
     * var init_temp = inp.get_init_coldstart_temp_land()
     * var data = init_temp['data']
     * data['islt'][0] += 0.1
     * inp.set_init_coldstart_temp_land(data)
     *
     * @param {object} data
     */
    set_init_coldstart_temp_land(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_init_coldstart_temp_land(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置初始化配置
     *
     * @param {bool} initfg                是否启用热启动
     *
     * @param {boolean} initfg
     */
    set_initfg(initfg) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_initfg(retptr, this.__wbg_ptr, initfg);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 设置库塘信息-基本属性
     *
     * Example:
     * lake_basic = inp.get_lake_basic()
     * data = lake_basic['data']
     * inp.set_lake_basic(data)
     *
     * @param {object} data
     */
    set_lake_basic(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_lake_basic(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置库塘信息-几何属性
     *
     * Example:
     * lake_geometry = inp.get_lake_geometry()
     * data = lake_geometry['data']
     * inp.set_lake_geometry(data)
     *
     * @param {object} data
     */
    set_lake_geometry(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_lake_geometry(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置库塘信息-渗透属性
     *
     * Example:
     * lake_permeation = inp.get_lake_permeation()
     * data = lake_permeation['data']
     * inp.set_lake_permeation(data)
     *
     * @param {object} data
     */
    set_lake_permeation(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_lake_permeation(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置陆域参数分组
     *
     * @param grpid     陆域参数分组id
     * @param grpname   陆域参数分组名称
     * @param refgrp    参考的陆域参数分组
     * @param shpid     子流域id
     * @param shpgrp    子流域对应的参数分组
     *
     * Example:
     *
     * var group = inp.get_land_groups();
     * var shpid = group.shpid;
     * var shpgrp = Array(shpid.length).fill(1);
     * shpgrp[1] = 3;
     * shpgrp[2] = 6;
     * var grpid = [1,3,6];
     * var grpname = ["西部山地", "东部平原", "南部林区"];
     * var refgrp = [0,0,1];
     * var data = {'grpid': grpid, 'grpname': grpname, 'refgrp': refgrp, 'shpid': shpid, 'shpgrp': shpgrp};
     * inp.set_land_groups(data);
     *
     * @param {object} data
     */
    set_land_groups(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_land_groups(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置陆域信息-子流域属性-HRU类型
     *
     * Example:
     * subhru1 = inp.get_land_hru1();
     * data = subhru1['data']
     * inp.set_land_hru1(data);
     * @param {object} data
     */
    set_land_hru1(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_land_hru1(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置陆域信息-子流域属性-HRU设置
     * sub_perc, ifwo_perc, agwo_perc 可以为null
     *
     * Example:
     * subhru2 = inp.get_land_hru2();
     * data = subhru2['data'];
     * inp.set_land_hru2(data);
     * @param {object} data
     */
    set_land_hru2(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_land_hru2(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置陆域信息-子流域属性
     *
     * @param melev     子流域平均高程(m)
     * Example:
     * subinfo = inp.get_land_subbasin();
     * data = subinfo['data'];
     * inp.set_land_subbasin(data);
     * @param {object} data
     */
    set_land_subbasin(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_land_subbasin(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置模型时间
     *
     * mstart   : 模拟起始时间, YYYY/MM/DD HH:mm:ss
     * mend     : 模拟结束时间, YYYY/MM/DD HH:mm:ss
     * mostart  : 输出起始时间, YYYY/MM/DD HH:mm:ss
     * moend    : 输出结束时间, YYYY/MM/DD HH:mm:ss
     * optlevel : 输出时间步长，逐日/逐小时
     * tsPrint  : 状态输出时间, YYYY/MM/DD HH:mm:ss
     *
     * 以上参数字段可选部分，例如：inp.set_model_time({'mstart': '2023/01/01 00:00:00', 'mend': '2023/12/31 23:00:00', 'optlevel': '逐小时'})
     *
     * @param {object} model_time
     */
    set_model_time(model_time) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_model_time(retptr, this.__wbg_ptr, addBorrowedObject(model_time));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置模块开关状态
     *
     * @param options {模块1: true/false, 模块2: true/false, ...}
     * Example:
     * inp.set_modules({'pwatfg': true, 'pqalfg': false, 'tempfg': false, 'detpdfg': true, 'tmdlfg': true, 'greenhousefg': true})
     *
     * @param {object} options
     */
    set_modules(options) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_modules(retptr, this.__wbg_ptr, addBorrowedObject(options));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置模型输出配置
     *
     * Example:
     * output_config = inp.get_output_config();
     * output_vars = output_config['output_vars'];
     * psprint = output_config['psprint'];   // 输出各个点源&河道抽水时序
     * psloadfg = output_config['psloadfg']; // 按点源/河道抽水输入格式输出
     * inp.set_output_config(output_vars, psprint, psloadfg);
     *
     * @param {object} output_vars
     * @param {boolean} _psprint
     * @param {boolean} psloadfg
     */
    set_output_config(output_vars, _psprint, psloadfg) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_output_config(retptr, this.__wbg_ptr, addBorrowedObject(output_vars), _psprint, psloadfg);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置高级模块-大棚模拟-大棚特性
     * @param {object} data
     */
    set_param_adv_greenhouse_property(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_adv_greenhouse_property(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置高级模块-大棚模拟-植被生长
     * @param {object} data
     */
    set_param_adv_greenhouse_vegetation(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_adv_greenhouse_vegetation(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置高级模块-大棚模拟-通风控制(月变值/基于棚内温度控制)
     * @param {object} data
     */
    set_param_adv_greenhouse_vomp(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_adv_greenhouse_vomp(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置高级模块-大棚模拟-通风控制(月度日变值)
     * @param {object} data
     */
    set_param_adv_greenhouse_vomp_daily(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_adv_greenhouse_vomp_daily(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置高级模块-蓄滞模拟-地表径流蓄滞水文参数
     *
     * Example:
     * var store_hydro = inp.get_param_adv_store_hydro()
     * var data = store_hydro['data']
     * data['crest_height'][0] += 0.1
     * inp.set_param_adv_store_hydro(data)
     *
     * @param {object} data
     */
    set_param_adv_store_hydro(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_adv_store_hydro(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置高级模块-蓄滞模拟-地表滞留水质参数
     *
     * Example:
     * var store_wqual = inp.get_param_adv_store_wqual()
     * var data = store_wqual['data']
     * data['drate'][0] += 0.1
     * inp.set_param_adv_store_wqual(data)
     *
     * @param {object} data
     */
    set_param_adv_store_wqual(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_adv_store_wqual(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置高级模块-负荷削减-面源削减控制
     *
     * Example:
     * var tmdl_npsrc = inp.get_param_adv_tmdlctrl_npsrc();
     * var data = tmdl_npsrc['data']
     * data['reduction_flow'][0] += 0.1
     * inp.set_param_adv_tmdlctrl_npsrc(data)
     * @param {object} data
     */
    set_param_adv_tmdlctrl_npsrc(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_adv_tmdlctrl_npsrc(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置高级模块-负荷削减-点源削减控制
     *
     * Example:
     * var tmdl_ptsrc = inp.get_param_adv_tmdlctrl_ptsrc();
     * var data = tmdl_ptsrc['data']
     * data['reduction_flow'][0] += 0.1
     * inp.set_param_adv_tmdlctrl_ptsrc(data)
     *
     * @param {object} data
     */
    set_param_adv_tmdlctrl_ptsrc(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_adv_tmdlctrl_ptsrc(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置高级模块-负荷削减-控制开关
     *
     * reduction_ptsrc: 点源削减控制开关
     * reduction_npsrc_surface: 面源削减控制子开关，仅对地表径流应用削减
     * reduction_npsrc_total: 面源削减控制子开关，对陆域总出流应用削减
     *
     * @param {boolean} reduction_ptsrc
     * @param {boolean} reduction_npsrc_surface
     * @param {boolean} reduction_npsrc_total
     */
    set_param_adv_tmdlctrl_switch(reduction_ptsrc, reduction_npsrc_surface, reduction_npsrc_total) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_adv_tmdlctrl_switch(retptr, this.__wbg_ptr, reduction_ptsrc, reduction_npsrc_surface, reduction_npsrc_total);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 设置参数配置-水文模拟-蒸散发-恒值参数(c120)
     *
     * Example:
     * param_hydro_evap_const = inp.get_param_hydro_evap_const()
     * data = param_hydro_evap_const['data']
     * inp.set_param_hydro_evap_const(data)
     *
     * @param {object} data
     */
    set_param_hydro_evap_const(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_hydro_evap_const(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置参数配置-水文模拟-蒸散发-lzetp(c100, c130, c200)
     *
     * Example1:
     * var param_hydro_evap_lzetp = inp.get_param_hydro_evap_lzetp()
     * var use_monthly = true
     * var data = param_hydro_evap_lzetp['monthly']['data']
     * inp.set_param_hydro_evap_lzetp(use_monthly, data)
     *
     * Example2:
     * var param_hydro_evap_lzetp = inp.get_param_hydro_evap_lzetp()
     * var use_monthly = false
     * var data = param_hydro_evap_lzetp['constant'].data
     * inp.set_param_hydro_evap_lzetp(use_monthly, data)
     *
     * @param {boolean} use_monthly
     * @param {object} data
     */
    set_param_hydro_evap_lzetp(use_monthly, data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_hydro_evap_lzetp(retptr, this.__wbg_ptr, use_monthly, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置参数配置-水文模拟-蒸散发-水面蒸发(c400)
     * @param {number} kc
     */
    set_param_hydro_evap_water(kc) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_hydro_evap_water(retptr, this.__wbg_ptr, kc);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 设置参数配置-水文模拟-下渗-恒值参数
     *
     * Example:
     * param_hydro_infil_const = inp.get_param_hydro_infil_const()
     * data = param_hydro_infil_const['data']
     * inp.set_param_hydro_infil_const(data)
     *
     * @param {object} data
     */
    set_param_hydro_infil_const(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_hydro_infil_const(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置参数配置-水文模拟-下渗-intfw(c100, c130, c180)
     * @param {boolean} use_monthly
     * @param {object} data
     */
    set_param_hydro_infil_intfw(use_monthly, data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_hydro_infil_intfw(retptr, this.__wbg_ptr, use_monthly, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置参数配置-水文模拟-下渗-uzsn(c100, c130, c160)
     * @param {boolean} use_monthly
     * @param {object} data
     */
    set_param_hydro_infil_uzsn(use_monthly, data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_hydro_infil_uzsn(retptr, this.__wbg_ptr, use_monthly, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置参数配置-水文模拟-灌溉-灌溉控制
     *
     * Example:
     * var control = inp.get_param_hydro_irrigation_control()
     * var data = control['data']
     * data['irrigID'][0] = 1
     * inp.set_param_hydro_irrigation_control(data)
     *
     * @param {object} data
     */
    set_param_hydro_irrigation_control(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_hydro_irrigation_control(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置参数配置-水文模拟-灌溉-灌溉控制-自定义灌溉需水量时序开关
     * @param {boolean} _switch
     */
    set_param_hydro_irrigation_control_tseries_switch(_switch) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_hydro_irrigation_control_tseries_switch(retptr, this.__wbg_ptr, _switch);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 设置参数配置-水文模拟-灌溉-etcoeff
     * @param {boolean} use_monthly
     * @param {object} data
     */
    set_param_hydro_irrigation_etcoeff(use_monthly, data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_hydro_irrigation_etcoeff(retptr, this.__wbg_ptr, use_monthly, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置参数配置-水文模拟-灌溉-灌溉位置
     *
     * Example:
     * var irrig_fraction = inp.get_param_hydro_irrigation_fraction()
     * var data = irrig_fraction['data']
     * data['fraction1'][0] += 0.1
     * inp.set_param_hydro_irrigation_fraction(data)
     * @param {object} data
     */
    set_param_hydro_irrigation_fraction(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_hydro_irrigation_fraction(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置参数配置-水文模拟-灌溉-PET选择
     * @param {boolean} use_constant
     * @param {object} data
     */
    set_param_hydro_irrigation_pet(use_constant, data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_hydro_irrigation_pet(retptr, this.__wbg_ptr, use_constant, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置参数配置-水文模拟-灌溉-灌溉水源
     *
     * Example
     * var irrig_source = inp.get_param_hydro_irrigation_source()
     * var data = irrig_source['data']
     * data['irrigdep'][0] += 0.1
     * inp.set_param_hydro_irrigation_source(data)
     * @param {object} data
     */
    set_param_hydro_irrigation_source(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_hydro_irrigation_source(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置参数配置-水文模拟-灌溉-灌溉时间
     *
     * Example:
     * var irrig_time = inp.get_param_hydro_irrigation_time()
     * var data = irrig_time['data']
     * data['etdays'][0] += 1
     * inp.set_param_hydro_irrigation_time(data)
     *
     * @param {object} data
     */
    set_param_hydro_irrigation_time(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_hydro_irrigation_time(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置参数配置-水文模拟-产汇流-cepsc(c100, c130, c150)
     * @param {boolean} use_monthly
     * @param {object} data
     */
    set_param_hydro_runoff_cepsc(use_monthly, data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_hydro_runoff_cepsc(retptr, this.__wbg_ptr, use_monthly, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置参数配置-水文模拟-产汇流-恒值参数(c110)
     *
     * Example:
     * param_hydro_runoff_const = inp.get_param_hydro_runoff_const()
     * data = param_hydro_runoff_const['data']
     * inp.set_param_hydro_runoff_const(data)
     *
     * @param {object} data
     */
    set_param_hydro_runoff_const(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_hydro_runoff_const(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置参数配置-水文模拟-产汇流-irc(c100, c130, c190)
     * @param {boolean} use_monthly
     * @param {object} data
     */
    set_param_hydro_runoff_irc(use_monthly, data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_hydro_runoff_irc(retptr, this.__wbg_ptr, use_monthly, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置参数配置-水文模拟-产汇流-nsur(c100, c130, c170)
     * @param {boolean} use_monthly
     * @param {object} data
     */
    set_param_hydro_runoff_nsur(use_monthly, data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_hydro_runoff_nsur(retptr, this.__wbg_ptr, use_monthly, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置参数配置-水文模拟-开关: 灌溉、干湿季调整(地下水流量校正)
     * @param {boolean} irrigfg
     * @param {boolean} gwdmfg
     */
    set_param_hydro_switch(irrigfg, gwdmfg) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_hydro_switch(retptr, this.__wbg_ptr, irrigfg, gwdmfg);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 设置参数配置-水文模拟-干湿季调整-地下水出流乘子
     *
     * Example:
     * var agwo_mult = inp.get_param_hydro_wetdryseason_agwo_mult()
     * var data = agwo_mult['data']
     * data['agwo_mult_wet'][0] += 0.1
     * data['agwo_mult_dry'][0] += 0.1
     * inp.set_param_hydro_wetdryseason_agwo_mult(data)
     *
     * @param {object} data
     */
    set_param_hydro_wetdryseason_agwo_mult(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_hydro_wetdryseason_agwo_mult(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置参数配置-水文模拟-干湿季调整-干湿季定义
     *
     * Example:
     * var def = inp.get_param_hydro_wetdryseason_definition()
     * var data = def['data']
     * data['sstype'][0] = 2
     * data['sstype'][1] = 1
     * inp.set_param_hydro_wetdryseason_definition(data)
     *
     * @param {object} data
     */
    set_param_hydro_wetdryseason_definition(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_hydro_wetdryseason_definition(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 获取参数配置-水质模拟-累积冲刷-acqop
     *
     * Example1:
     * var accumscour_acqop = inp.get_param_quality_accumscour_acqop()
     * var vqofg = 0
     * var data = accumscour_acqop['constant']['data']
     * data['acqop'][0] += 0.1
     * inp.set_param_quality_accumscour_acqop(vqofg, data)
     *
     * Example2:
     * var accumscour_acqop = inp.get_param_quality_accumscour_acqop()
     * var vqofg = 1
     * var data = accumscour_acqop['monthly']['data']
     * data['jan'][0] += 0.1
     * inp.set_param_quality_accumscour_acqop(vqofg, data)
     *
     * Example3:
     * var vqofg = 2
     * var data = {}
     * inp.set_param_quality_accumscour_acqop(vqofg, data)
     *
     * Example4:
     * var accumscour_acqop = inp.get_param_quality_accumscour_acqop()
     * var vqofg = 3
     * var data = accumscour_acqop['accum']['data']
     * data['accumID'][0] += 1
     * inp.set_param_quality_accumscour_acqop(vqofg, data)
     *
     * @param {number} vqofg
     * @param {object} data
     */
    set_param_quality_accumscour_acqop(vqofg, data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_quality_accumscour_acqop(retptr, this.__wbg_ptr, vqofg, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置参数配置-水质模拟-累积冲刷-恒值参数
     *
     * Example:
     * var accumscour_const = inp.get_param_quality_accumscour_const()
     * var data = accumscour_const['data']
     * data['wsqop'][0] += 0.1
     * inp.set_param_quality_accumscour_const(data)
     * @param {object} data
     */
    set_param_quality_accumscour_const(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_quality_accumscour_const(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置参数配置-水质模拟-累积冲刷-sqolim
     *
     * Example1:
     * var accumscour_sqolim = inp.get_param_quality_accumscour_sqolim()
     * var use_monthly = false
     * var data = accumscour_sqolim['constant']['data']
     * data['sqolim'][0] += 0.1
     * inp.set_param_quality_accumscour_sqolim(use_monthly, data)
     *
     * Example2:
     * var accumscour_sqolim = inp.get_param_quality_accumscour_sqolim()
     * var use_monthly = true
     * var data = accumscour_sqolim['monthly']['data']
     * data['jan'][0] += 0.1
     * inp.set_param_quality_accumscour_sqolim(use_monthly, data)
     *
     * @param {boolean} use_monthly
     * @param {object} data
     */
    set_param_quality_accumscour_sqolim(use_monthly, data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_quality_accumscour_sqolim(retptr, this.__wbg_ptr, use_monthly, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置参数配置-水质模拟-大气沉降-addclnd
     *
     * Example1:
     * var airdepos_addclnd = inp.get_param_quality_airdepos_addclnd()
     * var use_monthly = false
     * var data = airdepos_addclnd['constant']['data']
     * data['addclnd'][0] += 0.1
     * inp.set_param_quality_airdepos_addclnd(use_monthly, data)
     *
     * Example2:
     * var airdepos_addclnd = inp.get_param_quality_airdepos_addclnd()
     * var use_monthly = true
     * var data = airdepos_addclnd['monthly']['data']
     * data['jan'][0] += 0.1
     * inp.set_param_quality_airdepos_addclnd(use_monthly, data)
     *
     * @param {boolean} use_monthly
     * @param {object} data
     */
    set_param_quality_airdepos_addclnd(use_monthly, data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_quality_airdepos_addclnd(retptr, this.__wbg_ptr, use_monthly, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置参数配置-水质模拟-大气沉降-addcrch
     *
     * Example1:
     * var airdepos_addcrch = inp.get_param_quality_airdepos_addcrch()
     * var use_monthly = false
     * var data = airdepos_addcrch['constant']['data']
     * data['addcrch'][0] += 0.1
     * inp.set_param_quality_airdepos_addcrch(use_monthly, data)
     *
     * Example2:
     * var airdepos_addcrch = inp.get_param_quality_airdepos_addcrch()
     * var use_monthly = true
     * var data = airdepos_addcrch['monthly']['data']
     * inp.set_param_quality_airdepos_addcrch(use_monthly, data)
     * @param {boolean} use_monthly
     * @param {object} data
     */
    set_param_quality_airdepos_addcrch(use_monthly, data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_quality_airdepos_addcrch(retptr, this.__wbg_ptr, use_monthly, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置参数配置-水质模拟-大气沉降-awdclnd
     *
     * Example1:
     * var airdepos_awdclnd = inp.get_param_quality_airdepos_awdclnd()
     * var use_monthly = false
     * var data = airdepos_awdclnd['constant']['data']
     * data['adwclnd'][0] += 0.1
     * inp.set_param_quality_airdepos_awdclnd(use_monthly, data)
     *
     * Example2:
     * var airdepos_awdclnd = inp.get_param_quality_airdepos_awdclnd()
     * var use_monthly = true
     * var data = airdepos_awdclnd['monthly']['data']
     * data['jan'][0] += 0.1
     * inp.set_param_quality_airdepos_awdclnd(use_monthly, data)
     *
     * @param {boolean} use_monthly
     * @param {object} data
     */
    set_param_quality_airdepos_awdclnd(use_monthly, data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_quality_airdepos_awdclnd(retptr, this.__wbg_ptr, use_monthly, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置参数配置-水质模拟-大气沉降-awdcrch
     *
     * Example1:
     * var airdepos_awdcrch = inp.get_param_quality_airdepos_awdcrch();
     * var use_monthly = false
     * var data = airdepos_awdcrch['constant']['data']
     * data['awdcrch'][0] += 0.1
     * inp.set_param_quality_airdepos_awdcrch(use_monthly, data)
     *
     * Example2:
     * var airdepos_awdcrch = inp.get_param_quality_airdepos_awdcrch();
     * var use_monthly = true
     * var data = airdepos_awdcrch['monthly']['data']
     * data['jan'][0] += 0.1
     * inp.set_param_quality_airdepos_awdcrch(use_monthly, data)
     *
     * @param {boolean} use_monthly
     * @param {object} data
     */
    set_param_quality_airdepos_awdcrch(use_monthly, data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_quality_airdepos_awdcrch(retptr, this.__wbg_ptr, use_monthly, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置参数配置-水质模拟-大气沉降开关
     * @param {boolean} _switch
     */
    set_param_quality_airdepos_switch(_switch) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_quality_airdepos_switch(retptr, this.__wbg_ptr, _switch);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 设置参数配置-水质模拟-河道水质-降解
     *
     * Example:
     * var reachqual_decay = inp.get_param_quality_reachqual_decay()
     * var data = reachqual_decay['data']
     * data['decay'][0] = 0.1
     * inp.set_param_quality_reachqual_decay(data)
     *
     * @param {object} data
     */
    set_param_quality_reachqual_decay(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_quality_reachqual_decay(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置参数配置-水质模拟-土壤淋溶-aoqc
     *
     * Example1:
     * var soilleach_aoqc = inp.get_param_quality_soilleach_aoqc()
     * var use_monthly = false
     * var data = soilleach_aoqc['constant']['data']
     * data['aoqc'][0] += 0.1
     * inp.set_param_quality_soilleach_aoqc(use_monthly, data)
     *
     * Example2:
     * var soilleach_aoqc = inp.get_param_quality_soilleach_aoqc()
     * var use_monthly = true
     * var data = soilleach_aoqc['monthly']['data']
     * data['jan'][0] += 0.1
     * inp.set_param_quality_soilleach_aoqc(use_monthly, data)
     *
     * @param {boolean} use_monthly
     * @param {object} data
     */
    set_param_quality_soilleach_aoqc(use_monthly, data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_quality_soilleach_aoqc(retptr, this.__wbg_ptr, use_monthly, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置参数配置-水质模拟-土壤淋溶-恒值参数
     *
     * Example:
     * var soilleach_const = inp.get_param_quality_soilleach_const()
     * var data = soilleach_const['data']
     * data['ifwcdrate'][0] += 0.1
     * inp.set_param_quality_asoilleach_const(data)
     *
     * @param {object} data
     */
    set_param_quality_soilleach_const(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_quality_soilleach_const(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置参数配置-水质模拟-土壤淋溶-ioqc
     *
     * Example1:
     * var soilleach_ioqc = inp.get_param_quality_soilleach_ioqc()
     * var use_monthly = false
     * var data = soilleach_ioqc['constant']['data']
     * data['ioqc'][0] += 0.1
     * inp.set_param_quality_soilleach_ioqc(use_monthly, data)
     *
     * Example2:
     * var soilleach_ioqc = inp.get_param_quality_soilleach_ioqc()
     * var use_monthly = true
     * var data = soilleach_ioqc['monthly']['data']
     * data['jan'][0] += 0.1
     * inp.set_param_quality_soilleach_ioqc(use_monthly, data)
     *
     * @param {boolean} use_monthly
     * @param {object} data
     */
    set_param_quality_soilleach_ioqc(use_monthly, data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_quality_soilleach_ioqc(retptr, this.__wbg_ptr, use_monthly, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 按界面路径设置泥沙参数；三级路径把数据放在第四个实参，四级路径把数据放在第五个实参。
     * @param {string} level1
     * @param {string} level2
     * @param {string} level3
     * @param {any} level4_or_data
     * @param {any | null} [data]
     */
    set_param_sediment_card(level1, level2, level3, level4_or_data, data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(level1, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(level2, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            const ptr2 = passStringToWasm0(level3, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len2 = WASM_VECTOR_LEN;
            wasm.inp_set_param_sediment_card(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2, addHeapObject(level4_or_data), isLikeNone(data) ? 0 : addHeapObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 设置参数配置-温度模拟-河床热传导-恒值参数
     *
     * Example:
     * var constant = inp.get_param_temp_bed_constant()
     * var data = constant['data']
     * data['muddep'][0] += 0.1
     * inp.set_param_temp_bed_constant(data)
     * @param {object} data
     */
    set_param_temp_bed_constant(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_temp_bed_constant(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置参数配置-温度模拟-河床热传导-模拟方法
     *
     * Example:
     * var control = inp.get_param_temp_bed_control()
     * var data = control['data']
     * data['bedflg'][0] = '双界面模型(水-泥-地)'
     * inp.set_param_temp_bed_control(data)
     * @param {object} data
     */
    set_param_temp_bed_control(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_temp_bed_control(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置参数配置-温度模拟-河床热传导-tgrnd
     *
     * Example1:
     * var tgrnd = inp.get_param_temp_bed_tgrnd()
     * var use_monthly = false
     * var data = tgrnd['constant']['data']
     * data['tgrnd'][0] = 1.2
     * inp.set_param_temp_bed_tgrnd(data)
     *
     * Example2:
     * var tgrnd = inp.get_param_temp_bed_tgrnd()
     * var use_monthly = true
     * var data = tgrnd['monthly']['data']
     * inp.set_param_temp_bed_tgrnd(use_monthly, data)
     * @param {boolean} use_monthly
     * @param {object} data
     */
    set_param_temp_bed_tgrnd(use_monthly, data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_temp_bed_tgrnd(retptr, this.__wbg_ptr, use_monthly, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置参数配置-温度模拟-土壤温度-agwt
     * @param {boolean} use_monthly
     * @param {object} data
     */
    set_param_temp_soil_agwt(use_monthly, data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_temp_soil_agwt(retptr, this.__wbg_ptr, use_monthly, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置参数配置-温度模拟-土壤温度-aift
     * @param {boolean} use_monthly
     * @param {object} data
     */
    set_param_temp_soil_aift(use_monthly, data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_temp_soil_aift(retptr, this.__wbg_ptr, use_monthly, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置参数配置-温度模拟-土壤温度-aslt
     * @param {boolean} use_monthly
     * @param {object} data
     */
    set_param_temp_soil_aslt(use_monthly, data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_temp_soil_aslt(retptr, this.__wbg_ptr, use_monthly, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置参数配置-温度模拟-土壤温度-bgwt
     * @param {boolean} use_monthly
     * @param {object} data
     */
    set_param_temp_soil_bgwt(use_monthly, data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_temp_soil_bgwt(retptr, this.__wbg_ptr, use_monthly, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置参数配置-温度模拟-土壤温度-bift
     * @param {boolean} use_monthly
     * @param {object} data
     */
    set_param_temp_soil_bift(use_monthly, data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_temp_soil_bift(retptr, this.__wbg_ptr, use_monthly, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置参数配置-温度模拟-土壤温度-bslt
     * @param {boolean} use_monthly
     * @param {object} data
     */
    set_param_temp_soil_bslt(use_monthly, data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_temp_soil_bslt(retptr, this.__wbg_ptr, use_monthly, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置参数配置-温度模拟-土壤温度-计算方法(tsopfg)
     *
     * Example:
     * var method = inp.get_param_temp_soil_method()
     * var data = method['data']
     * data['tsopfg'][0] = 0
     * inp.set_param_temp_soil_method(data)
     * @param {object} data
     */
    set_param_temp_soil_method(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_temp_soil_method(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置参数配置-温度模拟-水体温度-温度系数
     *
     * Example:
     * var water_coeff = inp.get_param_temp_water_coeff()
     * var data = water_coeff['data']
     * data['cfsaex'][0] += 0.1
     * inp.set_param_temp_water_coeff(data)
     * @param {object} data
     */
    set_param_temp_water_coeff(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_param_temp_water_coeff(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 按前端选择增删点源TEMP或整组泥沙指标。
     * @param {object} options
     */
    set_point_qual_switches(options) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_point_qual_switches(retptr, this.__wbg_ptr, addBorrowedObject(options));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置河道参数分组
     *
     * @param grpid     河道参数分组id
     * @param grpname   河道参数分组名称
     * @param refgrp    参考的河道参数分组
     * @param shpid     河道id
     * @param shpgrp    河道对应的参数分组
     *
     * Example:
     *
     * var group = inp.get_reach_groups();
     * var shpid = group.shpid;
     * var shpgrp = Array(shpid.length).fill(1);
     * shpgrp[1] = 3;
     * shpgrp[2] = 7;
     * var grpid = [1,3,7];
     * var grpname = ["西部河道", "东部河道", "南部库塘"];
     * var refgrp = [0,1,1];
     * var data = {'grpid': grpid, 'grpname': grpname, 'refgrp': refgrp, 'shpid': shpid, 'shpgrp': shpgrp};
     * inp.set_reach_groups(data);
     *
     * 如果只修改分组，则shpid和shpgrp设置为[]即可
     * 如果只修改河道所属的分组，则grpid,grpname,refgrp设置为[]即可
     * @param {object} data
     */
    set_reach_groups(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_reach_groups(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置河道的拓扑关系
     *
     * @param rchtype     河道类型
     *
     * Example
     * reach_topo = inp.get_reach_topology()
     * data = reach_topo['data']
     * data['rchtype'][0] = '矩形堰库塘'
     * data['dsrchid'][0] = data['dsrchid'][1]
     * inp.set_reach_topology(data)
     *
     * @param {object} data
     */
    set_reach_topology(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_reach_topology(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置河道信息-基本属性
     *
     * Example
     * river_basic = inp.get_river_basic()
     * data = river_basic['data']
     * inp.set_river_basic(data)
     *
     * @param {object} data
     */
    set_river_basic(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_river_basic(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置河道信息-断面属性-主河道横断面
     *
     * 矩形(rectangle)、梯形(trapezoid)、自定义形状(custom)、标准(standard)
     * 矩形：rchid, width, height
     * 梯形：rchid, top_width, bot_width, height, left_slope
     * 自定义：rchid, x, y => rchid, "[x1,x2,,...,xn]", "[y1,y2,...,yn]"
     * 标准：rchid, 不需要提供其它参数
     *
     * Example
     * var rectangle = {'rchid': [1,2], 'width': [1,2], 'height': [3,4]};
     * var trapezoid = {'rchid': [3,4], 'top_width': [2,3], 'bot_width': [4,5], 'height': [3,3], 'left_slope': [0.1,0.2]};
     * var custom = {'rchid': [5,6], 'x': [ [0,0,1,1], [0,0,2,2] ], 'y': [ [1,0,0,1], [2,0,0,2] ]};
     * var standard = {'rchid': [7,8]};
     * inp.set_river_cross_section(rectangle, trapezoid, custom, standard);
     *
     * @param {object} rectangle
     * @param {object} trapezoid
     * @param {object} custom
     * @param {object} standard
     */
    set_river_cross_section(rectangle, trapezoid, custom, standard) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_river_cross_section(retptr, this.__wbg_ptr, addBorrowedObject(rectangle), addBorrowedObject(trapezoid), addBorrowedObject(custom), addBorrowedObject(standard));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
            heap[stack_pointer++] = undefined;
            heap[stack_pointer++] = undefined;
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置河道信息-水动力属性
     * Example
     * river_hydro = inp.get_river_hydro()
     * data = river_hydro['data']
     * inp.set_river_hydro(data)
     *
     * @param {object} data
     */
    set_river_hydro(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_river_hydro(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置河道信息-断面属性
     *
     * Example
     * river_section = inp.get_river_section()
     * data = river_section['data']
     * inp.set_river_section(data)
     *
     * @param {object} data
     */
    set_river_section(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_river_section(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置蓄滞模拟水文参数分组
     *
     * @param grpid     蓄滞模拟水文参数分组id
     * @param grpname   蓄滞模拟水文参数分组名称
     * @param refgrp    参考的蓄滞模拟水文参数分组
     * @param shpid     子流域id
     * @param shpgrp    子流域对应的参数分组
     *
     * Example:
     *
     * var group = inp.get_surf_groups();
     * var shpid = group.shpid;
     * var shpgrp = Array(shpid.length).fill(1);
     * shpgrp[1] = 2;
     * shpgrp[2] = 3;
     * var grpid = [1,2,3];
     * var grpname = ["蓄滞模拟水文分组一", "蓄滞模拟水文分组二", "蓄滞模拟水文分组三"];
     * var refgrp = [0,1,1];
     * var data = {'grpid': grpid, 'grpname': grpname, 'refgrp': refgrp, 'shpid': shpid, 'shpgrp': shpgrp};
     * inp.set_surf_groups(data);
     *
     * @param {object} data
     */
    set_surf_groups(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_surf_groups(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置模型水质组分
     *
     * Example
     * quals = {'dwqid': [1,2,31], 'qname': ['NH4','CODcr','Zn'], 'qunit': ['mg/L','mg/L','μg/L'], 'qrefs': [0, 0, 2]}
     * inp.set_water_quals(quals)
     *
     * @param {object} data
     */
    set_water_quals(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_water_quals(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置气象乘子和其它相关卡片(c10,c15,c20)
     *
     * Example
     * var weather_param_mult = inp.get_weather_param_mult();
     * var data = weather_param_mult['data'];
     * data['wparmmult1'][0] += 0.1;
     * inp.set_weather_param_mult(data)
     *
     * @param {object} data
     */
    set_weather_param_mult(data) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_weather_param_mult(retptr, this.__wbg_ptr, addBorrowedObject(data));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * 设置气象站点权重系数以及气象站点与子流域、子河道的高程差(c60,c470, c10, c15, c20)
     * var wstation_weight = inp.get_weather_weight();                // 气象站点权重
     * var wstation_elev = {'wstn_id': [1,2,3,...], "wstn_elev": [1930.1, 1836.7, 1760.5, ...]};  // 气象站点高程
     * Example:
     * inp.set_weather_weight_elev(weight, elev)
     * @param {object} wstation_weight
     * @param {object} wstation_elev
     */
    set_weather_weight_elev(wstation_weight, wstation_elev) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_set_weather_weight_elev(retptr, this.__wbg_ptr, addBorrowedObject(wstation_weight), addBorrowedObject(wstation_elev));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * @param {string} card_name
     * @param {string} col_name
     */
    sort(card_name, col_name) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(card_name, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(col_name, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len1 = WASM_VECTOR_LEN;
            wasm.inp_sort(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 统计各个子流域HRU面积及其占比
     * subbasins: 子流域编号, 为[]表示统计所有子流域
     * @param {Int32Array} subbasins
     * @returns {any}
     */
    stat_subbasin_hru(subbasins) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_stat_subbasin_hru(retptr, this.__wbg_ptr, addHeapObject(subbasins));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 统计各个子流域用地面积及其占比
     * subbasins: 选定的子流域，为空表示全部
     * @param {Int32Array} subbasins
     * @returns {any}
     */
    stat_subbasin_landuse(subbasins) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_stat_subbasin_landuse(retptr, this.__wbg_ptr, addHeapObject(subbasins));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 统计各个子流域坡度面积及其占比
     * subbasins: 选定的子流域，为空表示全部
     * @param {Int32Array} subbasins
     * @returns {any}
     */
    stat_subbasin_slope(subbasins) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_stat_subbasin_slope(retptr, this.__wbg_ptr, addHeapObject(subbasins));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 统计各个子流域土壤面积及其占比
     * subbasins: 选定的子流域，为空表示全部
     * @param {Int32Array} subbasins
     * @returns {any}
     */
    stat_subbasin_soil(subbasins) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_stat_subbasin_soil(retptr, this.__wbg_ptr, addHeapObject(subbasins));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} card_name
     * @param {Uint32Array} indices
     */
    subset(card_name, indices) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(card_name, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passArray32ToWasm0(indices, wasm.__wbindgen_export);
            const len1 = WASM_VECTOR_LEN;
            wasm.inp_subset(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 将Inp对象序列化为压缩的JSON字符串
     *
     * @returns {string}
     */
    to_b85z() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_to_b85z(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export3(deferred2_0, deferred2_1, 1);
        }
    }
    /**
     * 将Inp对象序列化为JSON字符串
     *
     * @returns {string}
     */
    to_str() {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_to_str(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_export3(deferred2_0, deferred2_1, 1);
        }
    }
    /**
     * 抽水增删后的卡片更新
     * withdraw: 抽水总览信息
     * @param {Array<any>} withdraw
     */
    withdraw_related_update(withdraw) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.inp_withdraw_related_update(retptr, this.__wbg_ptr, addBorrowedObject(withdraw));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
}
if (Symbol.dispose) Inp.prototype[Symbol.dispose] = Inp.prototype.free;

export class Reach {
    static __wrap(ptr) {
        const obj = Object.create(Reach.prototype);
        obj.__wbg_ptr = ptr;
        ReachFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ReachFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_reach_free(ptr, 0);
    }
    /**
     * 点击某个子流域后，更新选中的子流域
     * 如果该子流域未选中，则将该子流域及其所有上游子流域都选中
     * 如果该子流域已选中，则将该子流域所在的已选中子流域片区都取消选中
     * 返回选中的子流域的下标（不分组）
     * 参数： sind: 点击的子流域的下标
     * 返回： 选中的子流域的下标（不分组）
     * @param {number} sub_ind
     * @returns {any}
     */
    click(sub_ind) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.reach_click(retptr, this.__wbg_ptr, sub_ind);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 根据subid, rchid, dsrchid构建Reach
     * subid: 子流域ID
     * rchid: 子河道ID
     * dsrchid: 下游子河道ID
     * 注意：subid的顺序可能与rchid的顺序不一致，因此不能假定其顺序一致
     * @param {Int32Array} subid
     * @param {Int32Array} rchid
     * @param {Int32Array} dsrchid
     * @returns {Reach}
     */
    static from(subid, rchid, dsrchid) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.reach_from(retptr, addHeapObject(subid), addHeapObject(rchid), addHeapObject(dsrchid));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Reach.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取Reach的js对象，以供调试
     * @returns {any}
     */
    get_jsvalue() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.reach_get_jsvalue(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * 获取所选中的子流域ID
     * @returns {any}
     */
    get_sel_subid() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.reach_get_sel_subid(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}
if (Symbol.dispose) Reach.prototype[Symbol.dispose] = Reach.prototype.free;

export class Slope {
    static __wrap(ptr) {
        const obj = Object.create(Slope.prototype);
        obj.__wbg_ptr = ptr;
        SlopeFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        SlopeFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_slope_free(ptr, 0);
    }
    /**
     * @param {object} param
     * @returns {any}
     */
    divide(param) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.slope_divide(retptr, this.__wbg_ptr, addBorrowedObject(param));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * @param {string} jstr
     * @returns {Slope}
     */
    static from(jstr) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(jstr, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.slope_from(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Slope.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {number}
     */
    max() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.slope_max(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getFloat64(retptr + 8 * 0, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            if (r3) {
                throw takeObject(r2);
            }
            return r0;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}
if (Symbol.dispose) Slope.prototype[Symbol.dispose] = Slope.prototype.free;

export class Soil {
    static __wrap(ptr) {
        const obj = Object.create(Soil.prototype);
        obj.__wbg_ptr = ptr;
        SoilFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        SoilFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_soil_free(ptr, 0);
    }
    /**
     * @param {object} param
     * @returns {any}
     */
    divide(param) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.soil_divide(retptr, this.__wbg_ptr, addBorrowedObject(param));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
    /**
     * @param {string} jstr
     * @returns {Soil}
     */
    static from(jstr) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(jstr, wasm.__wbindgen_export, wasm.__wbindgen_export2);
            const len0 = WASM_VECTOR_LEN;
            wasm.soil_from(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return Soil.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {number}
     */
    max() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.soil_max(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getFloat64(retptr + 8 * 0, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            if (r3) {
                throw takeObject(r2);
            }
            return r0;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}
if (Symbol.dispose) Soil.prototype[Symbol.dispose] = Soil.prototype.free;

/**
 * A WASM wrapper for ckmeans_optimal
 * @param {Float64Array} data
 * @param {number | null} [k_min]
 * @param {number | null} [k_max]
 * @returns {any}
 */
export function ckmeans_optimal_wasm(data, k_min, k_max) {
    try {
        const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
        const ptr0 = passArrayF64ToWasm0(data, wasm.__wbindgen_export);
        const len0 = WASM_VECTOR_LEN;
        wasm.ckmeans_optimal_wasm(retptr, ptr0, len0, isLikeNone(k_min) ? 0xFFFFFF : k_min, isLikeNone(k_max) ? 0xFFFFFF : k_max);
        var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
        var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
        var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
        if (r2) {
            throw takeObject(r1);
        }
        return takeObject(r0);
    } finally {
        wasm.__wbindgen_add_to_stack_pointer(16);
    }
}

/**
 * A WASM wrapper for ckmeans
 * @param {Float64Array} data
 * @param {number} nclusters
 * @returns {Array<any>}
 */
export function ckmeans_wasm(data, nclusters) {
    try {
        const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
        const ptr0 = passArrayF64ToWasm0(data, wasm.__wbindgen_export);
        const len0 = WASM_VECTOR_LEN;
        wasm.ckmeans_wasm(retptr, ptr0, len0, nclusters);
        var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
        var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
        var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
        if (r2) {
            throw takeObject(r1);
        }
        return takeObject(r0);
    } finally {
        wasm.__wbindgen_add_to_stack_pointer(16);
    }
}

/**
 * @param {object} tbl1
 * @param {object} tbl2
 * @returns {any}
 */
export function compare_table(tbl1, tbl2) {
    try {
        const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
        wasm.compare_table(retptr, addHeapObject(tbl1), addHeapObject(tbl2));
        var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
        var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
        var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
        if (r2) {
            throw takeObject(r1);
        }
        return takeObject(r0);
    } finally {
        wasm.__wbindgen_add_to_stack_pointer(16);
    }
}

export function main() {
    wasm.main();
}

/**
 * A WASM wrapper for roundbreaks
 * @param {Float64Array} data
 * @param {number} nclusters
 * @returns {Float64Array}
 */
export function roundbreaks_wasm(data, nclusters) {
    try {
        const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
        const ptr0 = passArrayF64ToWasm0(data, wasm.__wbindgen_export);
        const len0 = WASM_VECTOR_LEN;
        wasm.roundbreaks_wasm(retptr, ptr0, len0, nclusters);
        var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
        var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
        var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
        if (r2) {
            throw takeObject(r1);
        }
        return takeObject(r0);
    } finally {
        wasm.__wbindgen_add_to_stack_pointer(16);
    }
}
export function __wbg_Error_67e7344beaa85059(arg0, arg1) {
    const ret = Error(getStringFromWasm0(arg0, arg1));
    return addHeapObject(ret);
}
export function __wbg___wbindgen_debug_string_0e68cf47c9cbd9b0(arg0, arg1) {
    const ret = debugString(getObject(arg1));
    const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_export, wasm.__wbindgen_export2);
    const len1 = WASM_VECTOR_LEN;
    getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
}
export function __wbg___wbindgen_is_object_edb6b15aa3afe12e(arg0) {
    const val = getObject(arg0);
    const ret = typeof(val) === 'object' && val !== null;
    return ret;
}
export function __wbg___wbindgen_is_undefined_8c687d0b90d5b524(arg0) {
    const ret = getObject(arg0) === undefined;
    return ret;
}
export function __wbg___wbindgen_string_get_92ab86bb19cbc12f(arg0, arg1) {
    const obj = getObject(arg1);
    const ret = typeof(obj) === 'string' ? obj : undefined;
    var ptr1 = isLikeNone(ret) ? 0 : passStringToWasm0(ret, wasm.__wbindgen_export, wasm.__wbindgen_export2);
    var len1 = WASM_VECTOR_LEN;
    getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
}
export function __wbg___wbindgen_throw_5d9e815e6fdf150f(arg0, arg1) {
    throw new Error(getStringFromWasm0(arg0, arg1));
}
export function __wbg_alert_d62c0188465bed11(arg0, arg1) {
    window.alert(getStringFromWasm0(arg0, arg1));
}
export function __wbg_debug_eb092a10b3338acb(arg0) {
    console.debug(getObject(arg0));
}
export function __wbg_error_756c5934221e6fee(arg0) {
    console.error(getObject(arg0));
}
export function __wbg_error_757e9472f8410341(arg0, arg1) {
    let deferred0_0;
    let deferred0_1;
    try {
        deferred0_0 = arg0;
        deferred0_1 = arg1;
        console.error(getStringFromWasm0(arg0, arg1));
    } finally {
        wasm.__wbindgen_export3(deferred0_0, deferred0_1, 1);
    }
}
export function __wbg_info_f25c01bee103395d(arg0) {
    console.info(getObject(arg0));
}
export function __wbg_log_363d83b9114c8831(arg0) {
    console.log(getObject(arg0));
}
export function __wbg_new_227d7c05414eb861() {
    const ret = new Error();
    return addHeapObject(ret);
}
export function __wbg_new_bebc3f4757acf305() {
    const ret = new Object();
    return addHeapObject(ret);
}
export function __wbg_new_ffa92086ea89f79c() {
    const ret = new Array();
    return addHeapObject(ret);
}
export function __wbg_new_from_slice_3b4c7f1456059f80(arg0, arg1) {
    const ret = new Float64Array(getArrayF64FromWasm0(arg0, arg1));
    return addHeapObject(ret);
}
export function __wbg_now_d1fb6650485d7f3e() {
    const ret = Date.now();
    return ret;
}
export function __wbg_parse_6937a9050adfb0e1() { return handleError(function (arg0, arg1) {
    const ret = JSON.parse(getStringFromWasm0(arg0, arg1));
    return addHeapObject(ret);
}, arguments); }
export function __wbg_push_bfdf956ba476f65b(arg0, arg1) {
    const ret = getObject(arg0).push(getObject(arg1));
    return ret;
}
export function __wbg_set_a377297433dfea63() { return handleError(function (arg0, arg1, arg2) {
    const ret = Reflect.set(getObject(arg0), getObject(arg1), getObject(arg2));
    return ret;
}, arguments); }
export function __wbg_stack_3b0d974bbf31e44f(arg0, arg1) {
    const ret = getObject(arg1).stack;
    const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_export, wasm.__wbindgen_export2);
    const len1 = WASM_VECTOR_LEN;
    getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
}
export function __wbg_stringify_54b3d9b61602aee6() { return handleError(function (arg0) {
    const ret = JSON.stringify(getObject(arg0));
    return addHeapObject(ret);
}, arguments); }
export function __wbg_warn_d3544c7814fab534(arg0) {
    console.warn(getObject(arg0));
}
export function __wbindgen_generic_0000000000000001(arg0) {
    // Cast intrinsic for `F64 -> Externref`.
    const ret = arg0;
    return addHeapObject(ret);
}
export function __wbindgen_generic_0000000000000002(arg0, arg1) {
    // Cast intrinsic for `Ref(String) -> Externref`.
    const ret = getStringFromWasm0(arg0, arg1);
    return addHeapObject(ret);
}
export function __wbindgen_object_drop_ref(arg0) {
    takeObject(arg0);
}
const DivideFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_divide_free(ptr, 1));
const DivideParamFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_divideparam_free(ptr, 1));
const HruFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_hru_free(ptr, 1));
const InpFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_inp_free(ptr, 1));
const ReachFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_reach_free(ptr, 1));
const SlopeFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_slope_free(ptr, 1));
const SoilFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_soil_free(ptr, 1));

function addHeapObject(obj) {
    if (heap_next === heap.length) heap.push(heap.length + 1);
    const idx = heap_next;
    heap_next = heap[idx];

    heap[idx] = obj;
    return idx;
}

function _assertClass(instance, klass) {
    if (!(instance instanceof klass)) {
        throw new Error(`expected instance of ${klass.name}`);
    }
}

function addBorrowedObject(obj) {
    if (stack_pointer == 1) throw new Error('out of js stack');
    heap[--stack_pointer] = obj;
    return stack_pointer;
}

function debugString(val) {
    // primitive types
    const type = typeof val;
    if (type == 'number' || type == 'boolean' || val == null) {
        return  `${val}`;
    }
    if (type == 'string') {
        return `"${val}"`;
    }
    if (type == 'symbol') {
        const description = val.description;
        if (description == null) {
            return 'Symbol';
        } else {
            return `Symbol(${description})`;
        }
    }
    if (type == 'function') {
        const name = val.name;
        if (typeof name == 'string' && name.length > 0) {
            return `Function(${name})`;
        } else {
            return 'Function';
        }
    }
    // objects
    if (Array.isArray(val)) {
        const length = val.length;
        let debug = '[';
        if (length > 0) {
            debug += debugString(val[0]);
        }
        for(let i = 1; i < length; i++) {
            debug += ', ' + debugString(val[i]);
        }
        debug += ']';
        return debug;
    }
    // Test for built-in
    const builtInMatches = /\[object ([^\]]+)\]/.exec(toString.call(val));
    let className;
    if (builtInMatches && builtInMatches.length > 1) {
        className = builtInMatches[1];
    } else {
        // Failed to match the standard '[object ClassName]'
        return toString.call(val);
    }
    if (className == 'Object') {
        // we're a user defined class or Object
        // JSON.stringify avoids problems with cycles, and is generally much
        // easier than looping through ownProperties of `val`.
        try {
            return 'Object(' + JSON.stringify(val) + ')';
        } catch (_) {
            return 'Object';
        }
    }
    // errors
    if (val instanceof Error) {
        return `${val.name}: ${val.message}\n${val.stack}`;
    }
    // TODO we could test for more things here, like `Set`s and `Map`s.
    return className;
}

function dropObject(idx) {
    if (idx < 1028) return;
    heap[idx] = heap_next;
    heap_next = idx;
}

function getArrayF64FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getFloat64ArrayMemory0().subarray(ptr / 8, ptr / 8 + len);
}

function getArrayJsValueFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    const mem = getDataViewMemory0();
    const result = [];
    for (let i = ptr; i < ptr + 4 * len; i += 4) {
        result.push(takeObject(mem.getUint32(i, true)));
    }
    return result;
}

let cachedDataViewMemory0 = null;
function getDataViewMemory0() {
    if (cachedDataViewMemory0 === null || cachedDataViewMemory0.buffer.detached === true || (cachedDataViewMemory0.buffer.detached === undefined && cachedDataViewMemory0.buffer !== wasm.memory.buffer)) {
        cachedDataViewMemory0 = new DataView(wasm.memory.buffer);
    }
    return cachedDataViewMemory0;
}

let cachedFloat64ArrayMemory0 = null;
function getFloat64ArrayMemory0() {
    if (cachedFloat64ArrayMemory0 === null || cachedFloat64ArrayMemory0.byteLength === 0) {
        cachedFloat64ArrayMemory0 = new Float64Array(wasm.memory.buffer);
    }
    return cachedFloat64ArrayMemory0;
}

function getStringFromWasm0(ptr, len) {
    return decodeText(ptr >>> 0, len);
}

let cachedUint32ArrayMemory0 = null;
function getUint32ArrayMemory0() {
    if (cachedUint32ArrayMemory0 === null || cachedUint32ArrayMemory0.byteLength === 0) {
        cachedUint32ArrayMemory0 = new Uint32Array(wasm.memory.buffer);
    }
    return cachedUint32ArrayMemory0;
}

let cachedUint8ArrayMemory0 = null;
function getUint8ArrayMemory0() {
    if (cachedUint8ArrayMemory0 === null || cachedUint8ArrayMemory0.byteLength === 0) {
        cachedUint8ArrayMemory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachedUint8ArrayMemory0;
}

function getObject(idx) { return heap[idx]; }

function handleError(f, args) {
    try {
        return f.apply(this, args);
    } catch (e) {
        wasm.__wbindgen_export4(addHeapObject(e));
    }
}

let heap = new Array(1024).fill(undefined);
heap.push(undefined, null, true, false);

let heap_next = heap.length;

function isLikeNone(x) {
    return x === undefined || x === null;
}

function passArray32ToWasm0(arg, malloc) {
    const ptr = malloc(arg.length * 4, 4) >>> 0;
    getUint32ArrayMemory0().set(arg, ptr / 4);
    WASM_VECTOR_LEN = arg.length;
    return ptr;
}

function passArrayF64ToWasm0(arg, malloc) {
    const ptr = malloc(arg.length * 8, 8) >>> 0;
    getFloat64ArrayMemory0().set(arg, ptr / 8);
    WASM_VECTOR_LEN = arg.length;
    return ptr;
}

function passStringToWasm0(arg, malloc, realloc) {
    if (realloc === undefined) {
        const buf = cachedTextEncoder.encode(arg);
        const ptr = malloc(buf.length, 1) >>> 0;
        getUint8ArrayMemory0().subarray(ptr, ptr + buf.length).set(buf);
        WASM_VECTOR_LEN = buf.length;
        return ptr;
    }

    let len = arg.length;
    let ptr = malloc(len, 1) >>> 0;

    const mem = getUint8ArrayMemory0();

    let offset = 0;

    for (; offset < len; offset++) {
        const code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr + offset] = code;
    }
    if (offset !== len) {
        if (offset !== 0) {
            arg = arg.slice(offset);
        }
        ptr = realloc(ptr, len, len = offset + arg.length * 3, 1) >>> 0;
        const view = getUint8ArrayMemory0().subarray(ptr + offset, ptr + len);
        const ret = cachedTextEncoder.encodeInto(arg, view);

        offset += ret.written;
        ptr = realloc(ptr, len, offset, 1) >>> 0;
    }

    WASM_VECTOR_LEN = offset;
    return ptr;
}

let stack_pointer = 1024;

function takeObject(idx) {
    const ret = getObject(idx);
    dropObject(idx);
    return ret;
}

let cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });
cachedTextDecoder.decode();
const MAX_SAFARI_DECODE_BYTES = 2146435072;
let numBytesDecoded = 0;
function decodeText(ptr, len) {
    numBytesDecoded += len;
    if (numBytesDecoded >= MAX_SAFARI_DECODE_BYTES) {
        cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });
        cachedTextDecoder.decode();
        numBytesDecoded = len;
    }
    return cachedTextDecoder.decode(getUint8ArrayMemory0().subarray(ptr, ptr + len));
}

const cachedTextEncoder = new TextEncoder();

if (!('encodeInto' in cachedTextEncoder)) {
    cachedTextEncoder.encodeInto = function (arg, view) {
        const buf = cachedTextEncoder.encode(arg);
        view.set(buf);
        return {
            read: arg.length,
            written: buf.length
        };
    };
}

let WASM_VECTOR_LEN = 0;


let wasm;
export function __wbg_set_wasm(val) {
    wasm = val;
}
